export const homeJSONLD = {
  '@context': 'http://schema.org',
  '@type': 'SoftwareApplication',
  applicationCategory: 'FinanceApplication',
  name: 'FlowAccount',
  operatingSystem: 'ANDROID,IOS,WEBAPP',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: 4.4,
    ratingCount: 346,
  },
  review: {
    '@type': 'review',
    reviewRating: {
      ratingValue: 4.4,
    },
    author: 'FlowAccount',
    reviewBody:
      'FlowAccount ถูกพัฒนามาเพื่อเจ้าของธุรกิจขนาดเล็กให้คุณขายของได้ทุกที่ ใช้งานง่าย สามารถเปิดบิล ใบเสนอราคา ใบกำกับภาษี ใบเสร็จรับเงิน พร้อมบริหารสต็อกสินค้าได้ผ่านปลายนิ้ว และเชื่อมต่อข้อมูลทั้งโปรแกรมคอมพิวเตอร์ มือถือ และแท็บเล็ตด้วยระบบคลาวด์โดยอัตโนมัติ ให้คุณทำงานต่อได้ทุกที่ทุกเวลา',
  },
  offers: [
    {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'THB',
    },
    {
      '@type': 'Offer',
      price: '1990.00',
      priceCurrency: 'THB',
    },
    {
      '@type': 'Offer',
      price: '2990.00',
      priceCurrency: 'THB',
    },
    {
      '@type': 'Offer',
      price: '4990.00',
      priceCurrency: 'THB',
    },
  ],
}

export const faqJSONLD = {
  '@context': 'http://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'โปรแกรมบัญชีสำเร็จรูปบนคลาวด์ คืออะไร?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'โปรแกรมบัญชีคลาวด์ เป็นแพลตฟอร์มออนไลน์ที่รวมฟังก์ชั่นการทำงานหลายๆ ด้านเข้าด้วยกัน เช่น การทำเอกสาร บัญชี การจัดการข้อมูล และการสื่อสาร เจ้าของธุรกิจ พนักงาน และนักบัญชี สามารถสร้างและจัดการข้อมูลบนฐานข้อมูลเดียวกัน แม้จะทำงานกันอยู่คนละที่ ระบบคลาวด์ทำหน้าที่เหมือนระบบคอมพิวเตอร์ขนาดใหญ่ ช่วยประมวลผลข้อมูลจำนวนมากๆ แล้วสรุปเป็นข้อมูลสำคัญออกมาเป็นผลประกอบการ หรือรายงานทางบัญชีแบบเรียลไทม์ เจ้าของธุรกิจจึงไม่จำเป็นต้องซื้อเซิร์ฟเวอร์มาเพื่อหาที่เก็บข้อมูลเอง',
      },
    },
    {
      '@type': 'Question',
      name: 'จะเริ่มใช้งาน FlowAccount ได้อย่างไร?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'สามารถสมัครสมาชิกได้ฟรี โดยไม่มีค่าใช้จ่ายใดๆทั้งสิ้น และเริ่มใช้งานเปิดบิลได้ทันที เมื่อเข้าใช้งาน 30 วันแรกคุณจะได้รับสิทธิพิเศษทดลองใช้งานฟังก์ชั่นต่างๆของ FlowAccount ฟรี! 30 วัน หลังจากนั้น ท่านสามารถเลือกสมัครใช้งานแพ็กเกจและชำระค่าบริการรายปีผ่านหน้าเว็บไซต์ได้ด้วยตนเอง',
      },
    },
    {
      '@type': 'Question',
      name: 'เมื่อหมดช่วงทดลองใช้งาน 30 วันแล้ว เรายังสามารถเข้าระบบได้ไหม?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'หลังจากหมดช่วงทดลองแล้ว ท่านจะยังสามารถ Login ใช้งานได้โดยเป็น Package Basic ซึ่งรองรับการเปิดเอกสารขายได้ไม่จำกัดรวมถึงสามารถดูข้อมูลที่เคยบันทึกไว้ในช่วงทดลองใช้งานในระบบ',
      },
    },
    {
      '@type': 'Question',
      name: ' การใช้งาน New FlowAccount จำเป็นต้องลงโปรแกรมหรือไม่?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'New FlowAccount เป็น โปรแกรมบัญชีออนไลน์ สามารถทำงานบนเว็บไซต์ได้ 100% โดยไม่ต้องลงโปรแกรมใดๆ สามารถสมัครสมาชิกและล็อคอินเข้าใช้งานได้ทันที',
      },
    },
    {
      '@type': 'Question',
      name: 'ข้อมูลที่อยู่บน New FlowAccount มีความปลอดภัยหรือไม่?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'ระบบฐานข้อมูลของเรา ปลอดภัยได้มาตรฐานสากล โดยเราใช้ฐานข้อมูลของ Amazon Web Services โดยเราไม่มีนโยบายเปิดเผยข้อมูลของผู้ใช้งานให้กับบุคคลที่ 3 และระบบ New FlowAccount มีการสำรองข้อมูล (BackUp) ข้อมูลอย่างสม่ำเสมอ',
      },
    },
  ],
}

export const landingJSONLD = {
  '@context': 'http://www.schema.org',
  '@type': 'Organization',
  name: 'FlowAccount | โปรแกรมบัญชีออนไลน์',
  url: 'https://flowaccount.com/',
  sameAs: ['https://www.facebook.com/flowaccount', 'https://www.youtube.com/channel/UCPQ_g-oZBwyLPKk_1IWAWOg'],
  logo: 'https://flowaccountcdn.com/My_company/FlowAccount.png',
  description:
    'FlowAccount คือ โปรแกรมบัญชี ออนไลน์ ใช้งานง่าย ช่วยเปิดเอกสาร ทำบัญชี มีแดชบอร์ดสรุปรายได้และค่าใช้จ่าย ใช้งานได้ทั้งเว็บไซต์และมือถือ ช่วยให้ทำงานได้ทุกที่ เริ่มต้นใช้งานได้ฟรี 30 วัน',
  address: {
    '@type': 'PostalAddress',
    streetAddress:
      '141/12 ชั้น 11 ยูนิต 12B อาคารชุด สกุลไทย สุรวงศ์ ทาวเวอร์ ถนนสุรวงศ์ แขวงสุริยวงศ์ เขตบางรัก กรุงเทพมหานคร',
    addressLocality: 'Bangkok',
    postalCode: '10500',
    addressCountry: 'TH',
    telephone: '+66 2 026 8989',
  },
}
export const tutorialsJSONLD = {
  '@context': 'http://www.schema.org',
  '@type': 'Organization',
  name: 'โปรแกรมบัญชีออนไลน์ -วิดีโอสอนใช้งาน | FlowAccount',
  url: 'https://flowaccount.com/',
  sameAs: ['https://www.facebook.com/flowaccount', 'https://www.youtube.com/channel/UCPQ_g-oZBwyLPKk_1IWAWOg'],
  logo: 'https://flowaccountcdn.com/My_company/FlowAccount.png',
  description:
    'วิดีโอสอนใช้งาน โปรแกรมบัญชี ออนไลน์ FlowAccount ครบทุกฟังก์ชั่น ให้คุณเริ่มต้นทำเอกสารง่ายๆ ได้ด้วยตนเอง และยังสามารถสอบถามทีมบริการได้ในระบบ',
  address: {
    '@type': 'PostalAddress',
    streetAddress:
      '141/12 ชั้น 11 ยูนิต 12B อาคารชุด สกุลไทย สุรวงศ์ ทาวเวอร์ ถนนสุรวงศ์ แขวงสุริยวงศ์ เขตบางรัก กรุงเทพมหานคร',
    addressLocality: 'Bangkok',
    postalCode: '10500',
    addressCountry: 'TH',
    telephone: '+66 2 026 8989',
  },
}
export const pricingJSONLD = {
  '@context': 'http://www.schema.org',
  '@type': 'Organization',
  name: 'โปรแกรมบัญชีออนไลน์ - ราคา และแพ็กเกจ | FlowAccount',
  url: 'https://flowaccount.com/',
  sameAs: ['https://www.facebook.com/flowaccount', 'https://www.youtube.com/channel/UCPQ_g-oZBwyLPKk_1IWAWOg'],
  logo: 'https://flowaccountcdn.com/My_company/FlowAccount.png',
  description:
    'ราคาและแพ็กเกจ โปรแกรมบัญชีออนไลน์ FlowAccount ที่เหมาะกับธุรกิจยุคใหม่ ช่วยเปิดเอกสาร ทำบัญชี พร้อมแดชบอร์ดสรุปรายได้และค่าใช้จ่าย ใช้งานได้ทุกที่ทั้งเว็บไซต์และมือถือ',
  address: {
    '@type': 'PostalAddress',
    streetAddress:
      '141/12 ชั้น 11 ยูนิต 12B อาคารชุด สกุลไทย สุรวงศ์ ทาวเวอร์ ถนนสุรวงศ์ แขวงสุริยวงศ์ เขตบางรัก กรุงเทพมหานคร',
    addressLocality: 'Bangkok',
    postalCode: '10500',
    addressCountry: 'TH',
    telephone: '+66 2 026 8989',
  },
}
